import Typography from '@mui/material/Typography';
import { useTagTasks } from 'features/tags/hooks/use-tag-tasks';
import React from 'react';
import { ID } from 'shared/types/id';

import * as Styled from './tag-count.style';

export type TagCountProps = {
  tagId: ID;
};

export const TagCount: React.FC<TagCountProps> = ({ tagId }) => {
  const tasks = useTagTasks(tagId);

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
